module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-tools"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v(" Dashboard"), (!_vm.isTowerCo() && _vm.org().shortName) ? _c('small', {
    staticClass: "text-info pull-right hidden-sm-and-down"
  }, [_vm._v(_vm._s(_vm.org().name))]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.org() && _vm.org().id) ? _c('div', [_c('el-tabs', {
    attrs: {
      "tab-position": "top"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" Tickets")]), _vm._v(" "), _c('tickets-table', {
    attrs: {
      "assign-id": _vm.org().id
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" Work List")]), _vm._v(" "), _c('site-workflow', {
    attrs: {
      "org-id": _vm.org().id
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Summary")]), _vm._v(" "), _c('ticket-summary')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Calendar")]), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "tickets"
    }
  })], 1)], 1)], 1) : _c('div', [_c('center', [_c('i', {
    staticClass: "fa fa-spinner fa-2x fa-spin text-primary"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b951344"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ContractorView.vue
// module id = 1585
// module chunks = 0